import { useRouter } from 'next/router';

import * as userResource from 'resources/user/hooks';
import * as dealResource from 'resources/deal/hooks';
import * as companyResource from 'resources/company/hooks';

// TODO: refactor
const useCompanyBranding = () => {
  const router = useRouter();
  const realtorId = router.query?.id || router.query?.agentId;
  const queryCompanyId = router.query?.companyId;

  const queryDealId = router.query?.dealId;

  // trying to get invitedClient for unauthorized pages
  const {
    isLoading: isInvitedClientLoading,
    data: invitedClient,
  } = userResource.useInvitedUser();

  // trying to get current user
  const {
    isLoading: isUserLoading,
    data: user,
  } = userResource.useCurrentUser({ enabled: !invitedClient && !isInvitedClientLoading });

  // detect realtor by known data
  const {
    isLoading: isRealtorLoading,
    data: realtor,
  } = userResource.useGetUsersByIds(
    realtorId ? [realtorId] : (user?.realtor_ids || invitedClient?.realtor_ids || []),
    { enabled: !!user || !!invitedClient || !!realtorId },
  );

  // detect deal by known data
  const {
    isLoading: isDealLoading,
    data: deal,
  } = dealResource.useDealById(queryDealId, { enabled: !!queryDealId });

  // trying to get companyID (in first and probably only one case by realtor)
  const companyId = queryCompanyId
    || realtor?.company_id
    || user?.company_id
    || invitedClient?.company_id
    || deal?.company_id;

  const {
    isLoading: isCompanyLoading,
    data: company,
  } = companyResource.useCompany(companyId, { enabled: !!companyId });

  const isBrandingSetUpped = company?.logo_url || company?.bgc_color;

  return {
    isBrandingLoading: isUserLoading
      || isCompanyLoading
      || isRealtorLoading
      || isInvitedClientLoading
      || isDealLoading,
    companyLogoUrl: company?.logo_url,
    companyBackground: company?.bgc_color,
    isBrandingSetUpped,
  };
};

export default useCompanyBranding;
